//Core
import React from "react"

//Styles
import style from "./style.module.scss"

//Components
import Form from "./Form"

const {
  container,
  wrapper,
  title,
  subtitle,
  rectIcon,
  curveIcon,
  dotsIcon,
} = style

const FooterForm = () => {
  return (
    <div className={container} id="form">
      <div className={rectIcon}></div>
      <div className={curveIcon}></div>
      <div className={dotsIcon}></div>
      <div className={wrapper}>
        <h4 className={title}>Чи можу я оформити Кредитні канікули</h4>
        <h5 className={subtitle}>
          Перевірте чи є у вас кредити, що підпадають під умови Кредитних
          канікул та оформіть заявку щодо участі в пропозиції
        </h5>
        <Form
          link={`https://refinance.tascombank.ua/api/credit-holiday/`}
        ></Form>
      </div>
    </div>
  )
}

export default FooterForm
